import PrescreeningFormShared from "@iv/shared/components/pages/PrescreeningListForm/PrescreenForms";

import { useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router";
import queryString from "query-string";

import SwtAlert from "../../../../Utils/SwtAlert";
import {
  getPrescreeningByPrescreeningId,
  editPreScreening,
  createPreScreening,
  getFilterOptionsAPI,
  getQuestionBankListAPI
} from "../../../../Apis/Pre_screening_api";;

const PrescreeningForm = () => {
  const questionPerPage = 50;
  const [totalQuestion, setTotalQuestion] = useState(0);

  const history = useHistory();
  const { search } = useLocation();
  const parsedQueryString = queryString.parse(search);
  const client_id = parsedQueryString?.client_id;
  const type = parsedQueryString?.type;
  const [role_name, setRoleName] = useState(parsedQueryString?.role_name || "");
  const [prescreen_id, setPrescreenId] = useState(parsedQueryString?.id || "");

  const [originalQuestionList, setOriginalQuestionList] = useState([]);
  const [technicalQuestionList, setTechnicalQuestionList] = useState([]);
  const [technicalAllowedTags, setTechnicalAllowedTags] = useState([]);
  const [techPageCount, setTechPageCount] = useState(1);
  const [techCurrentPage, setTechCurrentPage] = useState(0);
  const [searchText, setSearchText] = useState('');
  const defaultValue = {
    "title": "",
    "role": parsedQueryString?.role_name || "",
    "number_of_questions": 0,
    "cut_off_percentage": 0,
    "time_allotted": 10,
    "test_validity": 2,
    start_timestamp: '',
    time_window: '',
    last_allowed_submission_timestamp: '',
    "questions": []
  }
  const [interviewPrescreenData, setInterviewPrescreenData] = useState({...defaultValue});

  const getEditPrescreen = () => {
    let error = "";

    if (!client_id) {
      error = "Client id is not present";
    } else if (!prescreen_id) {
      error = "Prescreening id is not present";
    }

    if (error) {
      SwtAlert(error, 2000, "error", false);
      setTimeout(() => {
        history.goBack();
      }, 2000);
      return;
    }

    getPrescreeningByPrescreeningId({},prescreen_id)
      .then((res) => {
        console.log(res?.data)
        if (res?.status === 200) {
          setInterviewPrescreenData(res?.data);
          setRoleName(res?.data?.role || '');
        } else {
          SwtAlert(res?.data, 2000, "error", false);
        }
      })
      .catch((error) => {
        SwtAlert(error?.data, 2000, "error", false);
      });
  };

  const handleSaveChanges = (client_id, prescreen_id, interviewPrescreenData) => {
    if(interviewPrescreenData?.test_validity){
      delete interviewPrescreenData['start_timestamp'];
      delete interviewPrescreenData['time_window'];
      delete interviewPrescreenData['last_allowed_submission_timestamp'];
    }else{
      delete interviewPrescreenData['test_validity'];
      interviewPrescreenData['time_window'] =  parseInt(interviewPrescreenData?.time_window || 0);
    }

    console.log('interviewPrescreenData', interviewPrescreenData)
    // interviewPrescreenData['client_id'] = client_id
    interviewPrescreenData['pre_screening_id'] = interviewPrescreenData.id
    editPreScreening(interviewPrescreenData)
      .then((res) => {
        if (res?.status === 200) {
          history.push("/prescreening/list");
        } else {
          SwtAlert(res?.data, 1500, "error", false);
        }
      })
      .catch((error) => {
        SwtAlert(error.response, 1500, "error", false);
      });
  };

  const handleSavePrescreen = (
    interviewPrescreenData,
    client_id
  ) => {

    if(interviewPrescreenData?.test_validity){
      delete interviewPrescreenData['start_timestamp'];
      delete interviewPrescreenData['time_window'];
      delete interviewPrescreenData['last_allowed_submission_timestamp'];
    }else{
      delete interviewPrescreenData['test_validity'];
      interviewPrescreenData['time_window'] =  parseInt(interviewPrescreenData?.time_window || 0);
    }


    interviewPrescreenData['client_id'] = client_id
    createPreScreening(interviewPrescreenData)
      .then((res) => {
        if (res?.status === 200) {
          SwtAlert("Template created successfully", 1500, "success", false);
          history.push("/prescreening/list");
        } else {
          SwtAlert(res?.data, 1500, "error", false);
        }
      })
      .catch((error) => {
        SwtAlert(error.response, 1500, "error", false);
      });
  };

  const getAllowedtags = () => {
    getFilterOptionsAPI().then((res) => {
      if (res.status === 200) {
        const tempArr = [
          { label: "Select Tags", value: "", name: "Select all" },
        ];

        res?.data?.tags &&
          res?.data?.tags?.forEach((item) => {
            tempArr.push({ label: item, value: item, name: item });
          });
        setTechnicalAllowedTags(tempArr);
      } else {
        SwtAlert(res?.data, 2000, "error", false);
      }
    })
      .catch((error) => {
        SwtAlert(error, 2000, "error", false);
      });
  }

  const getQuestionByFilters = (payload = {}, type) => {
    return getQuestionList(payload, type)
  }

  const getQuestionList = (payload = {}, type) => {
    payload["page_size"] = questionPerPage;
    let filterData = JSON.parse(localStorage.getItem("filterApplied"));
    if(filterData?.length > 0) payload["difficulty_level"] = filterData;
    let filterResponse = null;
    if (!payload.page_number) payload["page_number"] = techCurrentPage + 1;

    filterResponse = getQuestionBankListAPI(payload).then(res => {
      if (res?.status === 200) {
        setOriginalQuestionList(res?.data?.data);
        setTechnicalQuestionList(res?.data?.data);
        setTechPageCount(Math.ceil(res?.data?.metadata?.total / questionPerPage));
        setTotalQuestion(res?.data?.metadata?.total);
      }
      return res?.data;
    }).catch(error => {
      SwtAlert(error?.data, 2000, "error", false);
      return error?.data;
    })
    return filterResponse;
  }

  useEffect(() => {
    // if (role_name && role_name?.length !== 0)
      getQuestionList({ role: [role_name] }, ['technical', 'theoretical']);
  }, [role_name]);

  useEffect(() => {
    if (role_name && role_name?.length !== 0) {
      let payload = {
        query_text: searchText
      };
      getQuestionList(payload, 'technical');
    }
  }, [techCurrentPage]);

  useEffect(() => {
console.log(type)

    if (type === "edit" || type === "duplicate") {
      getEditPrescreen();
    }else{
      setInterviewPrescreenData({...defaultValue});
    }
    getAllowedtags();
    localStorage.removeItem("filterApplied");
  }, []);

  return (
      ( type === 'new' || ((type === "edit" || type === "duplicate") && interviewPrescreenData)) &&
        <PrescreeningFormShared
          interviewPrescreenData={interviewPrescreenData}
          setInterviewPrescreenData={setInterviewPrescreenData}
          handleSaveChanges={handleSaveChanges}
          handleSavePrescreen={handleSavePrescreen}
          getQuestionByFilters={getQuestionByFilters}
          originalQuesList={originalQuestionList}
          technicalAllowedTags={technicalAllowedTags}
          setTechnicalAllowedTags={setTechnicalAllowedTags}
          technicalQuesList={technicalQuestionList}
          techPageCount={techPageCount}
          techCurrentPage={techCurrentPage}
          setTechCurrentPage={setTechCurrentPage}
          questionPerPage={questionPerPage}
          totalQuestion={totalQuestion}
          searchText={searchText}
          setSearchText={setSearchText}
        />
  );
};

export default PrescreeningForm;